import { Box } from '@chakra-ui/react';
import { GridTable, Text } from '@diamond/shared/ui';
import type { ColDef } from 'ag-grid-community';
import type { ReactNode } from 'react';

interface CollectionSearchResultsSectionProps<TRowData> {
  columnDefs: ColDef<TRowData>[];
  rowData: TRowData[];
  isLoading: boolean;
  height: string;
  minHeight: string;
  gridOptions: Record<string, unknown>;
  emptyState?: ReactNode;
  preSearchState?: ReactNode;
  sectionSx?: Record<string, unknown>;
  footer?: ReactNode;
}

export function CollectionSearchResultsSection<TRowData>({
  columnDefs,
  rowData,
  isLoading,
  height,
  minHeight,
  gridOptions,
  emptyState,
  preSearchState,
  sectionSx,
  footer,
}: CollectionSearchResultsSectionProps<TRowData>) {
  return (
    <>
      <Box sx={sectionSx}>
        <Text
          fontWeight={500}
          fontSize="20px"
          lineHeight="100%"
          letterSpacing="0%"
          color="#373F41"
          mb={4}
        >
          Hasil Pencarian ({rowData.length})
        </Text>
        <GridTable<TRowData>
          columnDefs={columnDefs}
          rowData={rowData}
          pagination={false}
          isLoading={isLoading}
          height={height}
          minHeight={minHeight}
          gridOptions={gridOptions}
        />
      </Box>

      {emptyState}
      {preSearchState}
      {footer}
    </>
  );
}
